import { Link } from 'react-router-dom';
import { genres } from '@/mocks/genres';
import { dramas } from '@/mocks/dramas';

export default function CategoryEntry() {
  const list = genres.slice(0, 8);

  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">按题材探索</h2>
          <p className="mt-2 text-sm text-foreground-500">从爱情到悬疑，找到属于你的那一类韩剧</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
        {list.map((g) => {
          const count = dramas.filter((d) => d.genres.includes(g.name)).length;
          return (
            <Link
              key={g.key}
              to={`/category/${g.key}`}
              className="group relative block cursor-pointer rounded-lg overflow-hidden aspect-[4/5] md:aspect-[3/4]"
            >
              <img
                src={g.image}
                alt={`${g.name}类韩剧`}
                title={`${g.name} - 热门韩剧电视剧列表`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading font-bold text-white text-xl md:text-2xl">{g.name}</h3>
                  <span className="text-xs text-white/80 bg-white/15 border border-white/25 rounded-full px-2 py-0.5">
                    {count} 部
                  </span>
                </div>
                <p className="mt-1.5 text-xs text-white/75 line-clamp-2">{g.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-300 opacity-0 group-hover:opacity-100 transition-opacity">
                  进入分类 <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}